// extracted by mini-css-extract-plugin
export default {"LoadingScreen":"LoadingScreen_LoadingScreen__KEmgA","pinCard":"LoadingScreen_pinCard__Ew6P5","pinNumber":"LoadingScreen_pinNumber__1a9lL"};